import 'css-chunksrc/client/scenes/planzoneResourceToProject/styles.scss';export default {
  "resourceToProject": "_resourceToProject_xpi53_1",
  "body": "_body_xpi53_6",
  "footer": "_footer_xpi53_10"
};